<template>
    <div>
        <PromiseCard />
    </div>
</template>

<script>
import PromiseCard from '@/views/biz/PromiseCard.vue';

export default {
    name: 'Biz',
    components: {
        PromiseCard,
    },
}
</script>

<style scoped>

</style>
